// eslint-disable-next-line @typescript-eslint/naming-convention,import/prefer-default-export
export enum LocationType {
  COUNTRY = 'COUNTRY',
  STATE = 'STATE',
  CITY = 'CITY',
}
